const message =
  "Sorry but you don't own any games on this steam account :(<br/> Go buy some games or use another SteamID";

export default message;
